import React, {
  Suspense,
  lazy,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react"
import {AiFillRead, AiFillSetting, AiOutlineShoppingCart} from "react-icons/ai"
import {FaMoneyCheckAlt} from "react-icons/fa"
import {GoSignOut} from "react-icons/go"
import {HiHeart, HiUsers} from "react-icons/hi"
import {useIntl} from "react-intl"
import {useDispatch} from "react-redux"
import {useSelector} from "react-redux/es/hooks/useSelector"
import {useNavigate} from "react-router-dom"
import {actions} from "../../Redux/AuthReducer"
import {resetCourseStore} from "../../Redux/CoursesReducer"
import deIcon from "../../assets/De-icon.png"
import ukIcon from "../../assets/uk-icon.png"
import {setLanguage, useLang} from "../../i18n/Metronici18n"
import {dateFormat} from "../../utils"
import "./style.scss"
import {MdNotifications, MdOutlineLocalOffer} from "react-icons/md"
import {BsCalendar2EventFill} from "react-icons/bs"
import config from "../../config"
import Loader, {ComponentLoader} from "../Loader/Loader"
const Notifications = lazy(() => import("./Notifications"))
const Login = lazy(() => import("../../components/LoginModal/components/login"))

const TopBar = ({generalDetails, setLocale, headerTwoActive}) => {
  const intl = useIntl()
  const lang = useLang()
  const [showLogin, setShowLogin] = useState(false)
  const navigate = useNavigate()
  const [showLocaleDropdown, setShowLocaleDropdown] = useState(false)
  const [showCommunities, setShowCommunities] = useState(true)
  const [openUserModal, setOpenUserModal] = useState(false)
  const [showNotifications, setShowNotifications] = useState(false)
  const dispatch = useDispatch()
  const user_sign_In = useSelector(
    (state) =>
      state.generalDetails.generalDetails?.general_settings?.user_sign_In
  )
  const implement_login_functionality = useSelector(
    (state) =>
      state.generalDetails.generalDetails?.general_settings
        ?.implement_login_functionality
  )
  const userInfo = useSelector((state) => state.auth?.user?.personalInformation)
  const joinedCommunitiesData = useSelector(
    (state) => state.communities.joinedCommunities
  )

  const memoizedJoinedCommunities = useMemo(
    () => joinedCommunitiesData,
    [joinedCommunitiesData]
  )

  const communitiesNotifications = useSelector(
    (state) => state?.communities?.communitiesNotifications
  )

  const memoizedCommunities = useMemo(
    () => communitiesNotifications,
    [communitiesNotifications]
  )

  const allCommunities = useSelector((state) => state.communities.communities)

  const isAuthorized = useSelector((state) => state.auth?.isAuthorized)

  const accessToken = sessionStorage.getItem("accessToken")

  const closeLoginModal = () => {
    setShowLogin(false)
  }
  const openLoginModal = () => {
    setShowLogin(true)
  }

  const isNewNotifications = useCallback(() => {
    return memoizedCommunities?.some((item) => item.is_seen == 0)
  }, [memoizedCommunities])

  const unreadNotificationsCount = useCallback(() => {
    return memoizedCommunities?.filter((item) => item.is_seen === 0)?.length
  }, [memoizedCommunities])

  const handleClick = (data) => {
    setShowLocaleDropdown((prev) => !prev)
    setLanguage(data.includes("de") ? "de" : "en")
    localStorage.setItem("language", data.includes("de") ? "de" : "en")
  }

  const logout = () => {
    navigate("/")
    dispatch(resetCourseStore())
    dispatch(actions.logout())
    sessionStorage.removeItem("accessToken")
    localStorage.removeItem(`${config.APP_NAME}_refreshToken`)
  }

  useEffect(() => {
    if (!isAuthorized) {
      setOpenUserModal(false)
    }
  }, [isAuthorized])

  const leavePage = (page) => {
    setOpenUserModal(false)
    navigate(`/${page.toLowerCase()}`)
  }

  useEffect(() => {
    if (
      (Object.keys(memoizedJoinedCommunities).length === 0 &&
        Object.keys(allCommunities).length === 0) ||
      !accessToken
    ) {
      setShowCommunities(false)
    } else {
      setShowCommunities(true)
    }
  }, [openUserModal, memoizedJoinedCommunities, allCommunities, accessToken])

  return (
    <>
      {showNotifications && (
        <Suspense>
          <Notifications
            show={showNotifications}
            handleClose={() => {
              setShowNotifications(false)
            }}
            id="topbar"
          />
        </Suspense>
      )}
      {showLogin && (
        <Suspense fallback={<Loader />}>
          <Login
            show={showLogin}
            closeModal={closeLoginModal}
          />
        </Suspense>
      )}
      <div
        className="topbar d-none d-lg-block"
        style={{
          backgroundColor: generalDetails.navigation_top_background,
          color: generalDetails.navigation_top_text,
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-sm-12 col-md-5">
              <div className="topbar-left">
                <div className="topbar-text fw-bold">{dateFormat(lang)}</div>
              </div>
            </div>
            <div className="col-sm-12 col-md-7">
              <div className="list-unstyled topbar-right">
                {showCommunities && (
                  <span
                    className="me-3 w-50px h-50px cursor-pointer position-relative"
                    type="button"
                    onClick={() => {
                      setShowNotifications(true)
                    }}
                  >
                    <MdNotifications
                      style={{color: "var(--accent-textcolor)"}}
                      size={25}
                      className="mb-3"
                    />
                    {isNewNotifications() && (
                      <span
                        className="rounded rounded-circle d-flex justify-content-center align-items-center bg-danger position-absolute translate-end top-0 start-50"
                        style={{
                          width:
                            unreadNotificationsCount() > 99 ? "20px" : "16px",
                          height: "16px",
                          color: "var(--accent-textcolor)",
                        }}
                      >
                        <span
                          className="text-white fw-bold"
                          style={{fontSize: "10px"}}
                        >
                          {unreadNotificationsCount() > 99
                            ? 99
                            : unreadNotificationsCount()}
                          {unreadNotificationsCount() > 99 && (
                            <span className="text-white">+</span>
                          )}
                        </span>
                      </span>
                    )}
                  </span>
                )}
                <div
                  className={`${
                    accessToken ? "me-2" : ""
                  } lang-icon lang-select`}
                >
                  <img
                    src={lang === "en" ? ukIcon : deIcon}
                    onClick={() => setShowLocaleDropdown((prev) => !prev)}
                    alt=""
                  />
                  <ul
                    className={`${
                      showLocaleDropdown ? "d-inline" : "d-none"
                    } lang-dropdown`}
                    style={{zIndex: 11}}
                  >
                    <li
                      className={`d-flex lang-icon user-language my-2 px-4 py-2 ${
                        lang === "de" ? "selected" : ""
                      }`}
                      onClick={() => handleClick("de")}
                    >
                      <img
                        src={deIcon}
                        alt=""
                      />
                    </li>
                    <li
                      className={` d-flex lang-icon user-language my-2 px-4 py-2 ${
                        lang === "en" ? "selected" : ""
                      }`}
                      onClick={() => handleClick("en")}
                    >
                      <img
                        src={ukIcon}
                        alt=""
                      />
                    </li>
                  </ul>
                </div>

                {!accessToken &&
                user_sign_In === "no" &&
                !headerTwoActive &&
                implement_login_functionality === "yes" ? (
                  <button
                    className="top-bar-button mx-4 fw-bold"
                    onClick={openLoginModal}
                    style={{fontSize: "14px", verticalAlign: "super"}}
                  >
                    {intl.formatMessage({id: "LOGIN"})}
                  </button>
                ) : null}
                {accessToken ? (
                  <>
                    <div
                      className="dropdown d-inline-flex ps-2"
                      style={{verticalAlign: "super"}}
                    >
                      <div
                        data-bs-toggle="dropdown"
                        className="dropdown-toggle"
                        type="button"
                        aria-expanded="false"
                        aria-haspopup="true"
                      >
                        {userInfo?.profile_photo_url &&
                        userInfo?.profile_photo_url.length > 0 ? (
                          <>
                            <img
                              alt="profile"
                              src={userInfo?.profile_photo_url}
                              className="d-inline-flex mx-2 mb-1 profile-pic"
                            />
                          </>
                        ) : userInfo?.firstname ? (
                          <div className=" d-inline-flex mx-2 profile-pic">
                            {`${userInfo?.firstname.toUpperCase()[0]}${
                              userInfo?.lastname.toUpperCase()[0]
                            }`}
                          </div>
                        ) : null}
                        <div className=" d-inline-flex">
                          {userInfo?.firstname}
                        </div>
                      </div>

                      <div
                        className="dropdown-menu dropdown-menu-end border border-success border-opacity-10"
                        style={{minWidth: "250px"}}
                      >
                        <div
                          className="user_modal_item dropdown-item cursor-pointer pt-2"
                          onClick={() => leavePage("posts-read")}
                        >
                          {/* Read Posts */}
                          <AiFillRead
                            style={{
                              width: "40px",
                              height: "20px",
                              fill: "var(--accent-color)",
                            }}
                          />
                          {intl.formatMessage({id: "TITLE_READ_POSTS"})}
                        </div>
                        <div
                          className="user_modal_item dropdown-item cursor-pointer"
                          onClick={() => leavePage("favourites")}
                        >
                          <HiHeart
                            style={{
                              width: "40px",
                              height: "20px",
                              fill: "var(--accent-color)",
                            }}
                          />
                          {intl.formatMessage({
                            id: "FAVOURITE_POSTS_TITLE",
                          })}
                        </div>
                        {showCommunities && (
                          <div
                            className="user_modal_item dropdown-item cursor-pointer"
                            onClick={() => leavePage("communities")}
                          >
                            <HiUsers
                              style={{
                                width: "40px",
                                height: "20px",
                                fill: "var(--accent-color)",
                              }}
                            />
                            {intl.formatMessage({
                              id: "COMMUNITIES_TITLE",
                            })}
                          </div>
                        )}
                        <hr className="user_modal_rule my-2" />
                        {/* Free Events */}
                        <div
                          className="user_modal_item dropdown-item cursor-pointer"
                          onClick={() => {
                            navigate("/account/purchases/free-events")
                          }}
                        >
                          <BsCalendar2EventFill
                            style={{
                              width: "40px",
                              height: "20px",
                              fill: "var(--accent-color)",
                            }}
                          />
                          {intl.formatMessage({
                            id: "ACCOUNT_SETTINGS_FREE_EVENTS_TITLE",
                          })}
                        </div>
                        {/* Products */}
                        <div
                          className="user_modal_item dropdown-item cursor-pointer"
                          onClick={() => {
                            navigate("/account/purchases/products")
                          }}
                        >
                          <AiOutlineShoppingCart
                            style={{
                              width: "40px",
                              height: "20px",
                              fill: "var(--accent-color)",
                            }}
                          />
                          {intl.formatMessage({
                            id: "ACCOUNT_SETTINGS_PRODUCTS_TITLE",
                          })}
                        </div>
                        {/* Subscriptions */}
                        <div
                          className="user_modal_item dropdown-item cursor-pointer"
                          onClick={() => {
                            navigate("/account/purchases/subscriptions")
                          }}
                        >
                          <FaMoneyCheckAlt
                            style={{
                              width: "40px",
                              height: "20px",
                              fill: "var(--accent-color)",
                            }}
                          />
                          {intl.formatMessage({
                            id: "ACCOUNT_SETTINGS_SUBSCRIPTIONS_TITLE",
                          })}
                        </div>
                        {/* Offers */}
                        <div
                          className="user_modal_item dropdown-item cursor-pointer"
                          onClick={() => {
                            navigate("/account/purchases/offer")
                          }}
                        >
                          <MdOutlineLocalOffer
                            style={{
                              width: "40px",
                              height: "20px",
                              fill: "var(--accent-color)",
                            }}
                          />
                          {intl.formatMessage({
                            id: "ACCOUNT_SETTINGS_OFFERS_TITLE",
                          })}
                        </div>

                        <hr className="user_modal_rule my-2" />

                        <div
                          className="user_modal_item dropdown-item cursor-pointer"
                          onClick={() => {
                            setOpenUserModal(false)
                            navigate(`/account`)
                          }}
                        >
                          <AiFillSetting
                            style={{
                              width: "40px",
                              height: "20px",
                              fill: "var(--accent-color)",
                            }}
                          />
                          {intl.formatMessage({
                            id: "SHARED_COMPONENTS_TOPBAR_ACCOUNT_SETTINGS",
                          })}
                        </div>
                        <div
                          className="user_modal_item dropdown-item cursor-pointer"
                          onClick={logout}
                        >
                          <GoSignOut
                            style={{
                              width: "40px",
                              height: "20px",
                              fill: "var(--accent-color)",
                            }}
                          />
                          {intl.formatMessage({
                            id: "SHARED_COMPONENTS_TOPBAR_LOGOUT",
                          })}
                        </div>
                      </div>
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default TopBar
